(function () {
  function init(root) {
    if (!root || root.dataset.lbInit === '1') return;
    root.dataset.lbInit = '1';

    var progress = root.querySelector('[data-lb-progress]');
    var railLabel = root.querySelector('[data-lb-rail-label]');
    var railDots = Array.prototype.slice.call(root.querySelectorAll('[data-lb-rail-dot]'));
    var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-lb-chapter]'));
    var drawer = root.querySelector('[data-lb-drawer]');
    var backdrop = root.querySelector('[data-lb-backdrop]');
    var drawerBody = root.querySelector('[data-lb-drawer-body]');
    var drawerTitle = root.querySelector('[data-lb-drawer-title]');

    function openDrawer(key) {
      var script = root.querySelector('script[type="application/json"][data-lb-looks]');
      if (!script || !drawer || !drawerBody) return;
      var looks = {};
      try { looks = JSON.parse(script.textContent || '{}'); } catch (e) { return; }
      var data = looks[key];
      if (!data) return;
      if (drawerTitle) drawerTitle.textContent = data.title || 'Shop the Look';
      drawerBody.innerHTML = (data.items || []).map(function (item) {
        return (
          '<div class="lookbook-cinema__drawer-item">' +
            (item.img ? '<img class="lookbook-cinema__drawer-item-img" src="' + item.img + '" alt="">' : '<div class="lookbook-cinema__drawer-item-img"></div>') +
            '<div>' +
              '<h4>' + (item.name || '') + '</h4>' +
              '<div class="price">' + (item.price || '') + '</div>' +
              (item.url ? '<a class="atc" href="' + item.url + '">View / Add</a>' : '') +
            '</div>' +
          '</div>'
        );
      }).join('');
      drawer.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    }

    function closeDrawer() {
      if (drawer) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
      }
      if (backdrop) backdrop.classList.remove('is-open');
    }

    root.querySelectorAll('[data-lb-open-look]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openDrawer(btn.getAttribute('data-lb-open-look'));
      });
    });
    var closeBtn = root.querySelector('[data-lb-close-drawer]');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    function onScroll() {
      if (!chapters.length) return;
      var rootRect = root.getBoundingClientRect();
      var rootTop = window.scrollY + rootRect.top;
      var rootHeight = root.offsetHeight;
      var max = Math.max(rootHeight - window.innerHeight, 1);
      var scrolled = Math.min(Math.max(window.scrollY - rootTop, 0), max);
      if (progress) progress.style.width = (scrolled / max) * 100 + '%';

      var current = chapters[0];
      for (var i = 0; i < chapters.length; i++) {
        if (chapters[i].getBoundingClientRect().top <= window.innerHeight * 0.45) {
          current = chapters[i];
        }
      }
      if (railLabel) railLabel.textContent = current.getAttribute('data-lb-rail') || '';
      railDots.forEach(function (dot) {
        var on = dot.getAttribute('data-lb-target') === current.id;
        dot.classList.toggle('is-active', on);
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    railDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var el = document.getElementById(dot.getAttribute('data-lb-target'));
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      });
    });

    var reveals = root.querySelectorAll('.lookbook-cinema__reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) e.target.classList.add('is-in');
        });
      }, { threshold: 0.18 });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    }
  }

  function boot() {
    document.querySelectorAll('[data-lookbook-cinema]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector
      ? e.target.querySelector('[data-lookbook-cinema]') || (e.target.matches && e.target.matches('[data-lookbook-cinema]') ? e.target : null)
      : null;
    if (root) {
      root.dataset.lbInit = '';
      init(root);
    } else {
      boot();
    }
  });
})();
